
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { EmergencyButton } from '@/components/EmergencyButton';
import { toast } from 'sonner';

export const Hero = () => {
  const navigate = useNavigate();

  const handleExternalLogin = () => {
    // This would be replaced with your actual external login URL
    const externalLoginUrl = "https://auth.myqoop.com";
    
    // For demo purposes, we're redirecting to the login page that will then simulate a redirect
    navigate('/login');
    
    // In a real application, we would redirect to the external URL:
    // window.location.href = externalLoginUrl;
    
    toast.info('Redirecting to login portal...');
  };

  return (
    <section className="relative h-screen flex items-center justify-start bg-black">
      {/* Full-screen background image with overlay */}
      <div 
        className="absolute inset-0 z-0 bg-cover bg-center" 
        style={{ backgroundImage: 'url("/lovable-uploads/d208fa5b-4e06-412e-a8ca-a2d3ef63eb13.png")', }}
      >
        {/* Dark overlay for better text readability */}
        <div className="absolute inset-0 bg-black/60"></div>
        
        {/* Photo credit */}
        <div className="absolute bottom-2 right-4 text-xs text-white/80 z-10">
          Creator: JeremySeanWilliamsRIVERVOICES.ca<br />
          Copyright: RiverVoices.ca
        </div>
      </div>
      
      <div className="container mx-auto px-8 md:px-12 relative z-10">
        <div className="max-w-xl space-y-6 text-white pr-4 md:pr-12">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight leading-tight">
            <span className="font-normal">Stop Postponing</span> Peace of Mind. <span className="font-normal">Your</span> 15-Minute <span className="font-normal">Emergency Plan Starts</span> Now.
          </h1>
          
          <p className="body-lg text-white/80 text-pretty">
            qoop creates a customized emergency preparedness plan tailored to your unique situation in minutes, not hours.
          </p>
          
          <div className="flex flex-wrap gap-4 pt-4">
            <Button 
              className="font-medium bg-amber-400 hover:bg-amber-500 text-black px-6 py-6 text-base"
              onClick={handleExternalLogin}
            >
              Start Your Plan Now
            </Button>
            <Link to="/features">
              <EmergencyButton variant="outline" className="font-medium px-6 py-6 text-base">
                See How It Works
              </EmergencyButton>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
